export default __webpack_public_path__ + "static/media/Aarom.0975c963.webp";